import { z } from "zod";
import webflowFieldTypeSchema from "./webflow-field-type-schema";
import { SupportedMacawField } from "../../../__generated__/gql/graphql";

const schema = z
  .array(
    z
      .object({
        webflowField: z.object({
          id: z.string(),
          name: z.string(),
          type: webflowFieldTypeSchema,
          displayName: z.string(),
          isRequired: z.boolean(),
          isEditable: z.boolean(),
          options: z
            .array(z.object({ value: z.string(), label: z.string() }))
            .nullable()
            .optional(),
        }),
        macawField: z.nativeEnum(SupportedMacawField).optional().nullable(),
        defaultValue: z.string().optional().nullable(),
      })
      .refine(
        (row) =>
          !row.webflowField.isRequired ||
          (!!row.webflowField.isRequired &&
            !!(row.macawField || row.defaultValue)),
        {
          message: "Required",
        },
      ),
  )
  .min(1);

export default schema;
